import {axiosGetAuthorize, axiosPostAuthorize} from '../AxiosRequests';
import{SetSystemConfiguration, GetSystemConfiguration} from '../ApiEndPoints';

export default class SetSystemConfigurationServices {
     
    //** Call API : */
    async setSystemConfiguration(request) {
        return axiosPostAuthorize(SetSystemConfiguration, request);
    }

     //** Call API : */
     async getSystemConfiguration() {
        return axiosGetAuthorize(GetSystemConfiguration);
    }
}
